export default import.meta.ROLLDOWN_FILE_URL_OxgPY7jd89vmgHQlmb5h_Q